var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_less"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11488_39519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11488_39519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M4.50078 9.75078C4.36745 9.61745 4.30078 9.45356 4.30078 9.25911C4.30078 9.06467 4.36745 8.90078 4.50078 8.76745L7.50078 5.76745C7.57856 5.68967 7.65911 5.63411 7.74245 5.60078C7.82578 5.56745 7.91189 5.55078 8.00078 5.55078C8.08967 5.55078 8.17578 5.56745 8.25911 5.60078C8.34245 5.63411 8.423 5.68967 8.50078 5.76745L11.5174 8.78411C11.6508 8.91745 11.7202 9.07578 11.7258 9.25911C11.7313 9.44245 11.6619 9.60634 11.5174 9.75078C11.3841 9.88411 11.2202 9.95078 11.0258 9.95078C10.8313 9.95078 10.6674 9.88411 10.5341 9.75078L8.00078 7.23411L5.46745 9.76745C5.33411 9.90078 5.17578 9.96745 4.99245 9.96745C4.80911 9.96745 4.64523 9.89523 4.50078 9.75078Z",
    fill: "#D3135A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLess);
export default __webpack_public_path__ + "static/media/expand_less.e7874cd804f57f17f9655671eb922113.svg";
export { ForwardRef as ReactComponent };